import { Box, Container, CssBaseline } from "@material-ui/core";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import Copyright from "../Components/Copyright";
import Sidebar from "../Components/Sidebar";
import Topbar from "../Components/Topbar";
import { getToken } from "./Common";
import { useStyles } from "./Styles";

// handle the private routes
function PrivateRoute({ component: Component, ...rest }) {
  const classes = useStyles();
  return (
    <Route
      render={() =>
        getToken() ? (
          <React.Fragment>
            <CssBaseline />
            <Topbar props={{ ...rest }} />
            <Sidebar />
            <main className={classes.content}>
              <div className={classes.appBarSpacer} />
              <Container maxWidth="lg" className={classes.container}>
                <Component {...rest} />
                <Box pt={4}>
                  <Copyright />
                </Box>
              </Container>
            </main>
          </React.Fragment>
        ) : (
          <Redirect to={{ pathname: "/login" }} />
        )
      }
    />
  );
}

export default PrivateRoute;
